import { render, staticRenderFns } from "./html/animal-quiz.html?vue&type=template&id=7884fb7c&"
import script from "./fusion-canadian-animal-type-quiz.vue?vue&type=script&lang=js&"
export * from "./fusion-canadian-animal-type-quiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports